import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import Style from "../addStore.module.scss";
import useDineHours from "./useDineHours";

const DineHours = ({ formik, getFieldError }) => {
  const {
    handleNext,
    handleCloseModal,
    handleTimeChange,
    daysOfWeek,
    handleToggle,
    getTimeValue,
    getStatus,
    // getMinToTime,
    // dineInTimeError,
  } = useDineHours(formik);

  return (
    <>
      <div className="form-check form-switch pro-mb-4">
        <input
          className="form-check-input cursor-pointer"
          type="checkbox"
          role="switch"
          id="dine_in"
          name="dine_in"
          checked={Boolean(formik.values?.dine_in === 1) ?? false}
          onChange={(e) => {
            formik.setFieldValue("dine_in", e.target.checked ? 1 : 2);
          }}
        />
        <label htmlFor="dine_in" className="pro-check-label">
          Set Dine-in Hour
        </label>
        {getFieldError("dine_in") && (
          <div className={`${Style.form_toggle_err_msg}`}>Please select at least one day's hours.</div>
        )}
      </div>

      {/* {formik.values?.dine_in === 1 && ( */}
        <>
          {daysOfWeek.map((day) => (
            <div
              key={day}
              className={`pro-d-flex pro-flex-column pro-mb-4 ${Style.time_wrap}`}
            >
              <label className="pro-font-sm pro-mb-1 pro-fw-medium">
                {day}
              </label>
              <div
                className={`pro-d-flex pro-items-center ${Style.time_picker_wrap}`}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={getTimeValue(day, "from") || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "from", newValue)
                    }
                    className="time-picker"
                     slotProps={{
                      actionBar: {
                        actions: ["clear", "accept"],
                        sx: {
                          "& .MuiButton-root:first-of-type": {
                            background: "none !important",
                            border: "none",
                            boxShadow: "none",
                            textTransform: "capitalize",
                            color: "var(--pro-primary) !important",
                            fontSize: "14px",
                            fontWeight: 600,
                            "&:hover": {
                              background: "none !important",
                              color: "var(--pro-primary-hover) !important",
                            },
                          },
                        },
                      },
                    }}
                    disabled={
                      getStatus(day)?.toString() === "2" ||
                      formik.values.dine_in === 2
                    }
                  />
                  <span className="pro-px-3 pro-d-flex pro-items-center">
                    <span className="material-symbols-outlined x4">
                      {" "}
                      remove{" "}
                    </span>
                  </span>

                  <TimePicker
                    value={getTimeValue(day, "to") || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "to", newValue)
                    }
                    className="time-picker"
                    // minTime={getMinToTime(day)}
                    slotProps={{
                      actionBar: {
                        actions: ["clear", "accept"],
                        sx: {
                          "& .MuiButton-root:first-of-type": {
                            background: "none !important",
                            border: "none",
                            boxShadow: "none",
                            textTransform: "capitalize",
                            color: "var(--pro-primary) !important",
                            fontSize: "14px",
                            fontWeight: 600,
                            "&:hover": {
                              background: "none !important",
                              color: "var(--pro-primary-hover) !important",
                            },
                          },
                        },
                      },
                    }}
                    disabled={
                      getStatus(day)?.toString() === "2" ||
                      formik.values.dine_in === 2
                    }
                  />
                  <div className="form-check form-switch pro-mb-0 pro-ms-auto">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id={`${day}-switch`}
                      checked={getStatus(day)?.toString() === "1" || false}
                      onChange={(e) => handleToggle(day, e.target.checked)}
                      disabled={formik.values.dine_in?.toString() === "2"}
                    />
                  </div>
                </LocalizationProvider>
              </div>
              {/* {pickupTimeError[day] !== null && (
                <span className="error pro-mt-2 pro-font-xs pro-lh-1">
                  {pickupTimeError[day]}
                </span>
              )} */}
            </div>
          ))}
          <div>
            <Input
              label={"Dine-in Note"}
              type="text"
              id="dine_in_note"
              name="dine_in_note"
              className={`pro-input lg ${
                getFieldError("dine_in_note") && " error"
              }`}
              {...formik.getFieldProps("dine_in_note")}
              error={getFieldError("dine_in_note")}
              errorMessage={getFieldError("dine_in_note")}
              disabled={formik.values.dine_in?.toString() === "2"}
            />
          </div>
          <div className="pro-rtl">
            <Input
              label={"(ملاحظة حول تناول الطعام في المطعم)Dine-in Note"}
              type="text"
              id="alias_dine_in_note"
              name="alias_dine_in_note"
              className={`pro-input lg ${
                getFieldError("alias_dine_in_note") && " error"
              }`}
              {...formik.getFieldProps("alias_dine_in_note")}
              error={getFieldError("alias_dine_in_note")}
              errorMessage={getFieldError("alias_dine_in_note")}
              disabled={formik.values.dine_in?.toString() === "2"}
            />
          </div>
        </>
      {/* )} */}
      <div className={`col-12 pro-d-flex pro-justify-end pro-mt-auto pro-pb-5`}>
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCloseModal}
          type="button"
        >
          Cancel
        </Button>
        <Button className={"pro-btn-primary lg pro-ms-3"} onClick={handleNext}>
          {"Next"}
        </Button>
      </div>
    </>
  );
};

export default DineHours;
